var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 6C12.9854 6 15 8.01457 15 10.5C15 12.9854 12.9854 15 10.5 15C8.01457 15 6 12.9854 6 10.5C6 8.01457 8.01457 6 10.5 6ZM10.5 4C14.09 4 17 6.91 17 10.5C17 11.9342 16.5356 13.2598 15.749 14.3347L19.7175 18.3033C19.9128 18.4986 19.9128 18.8151 19.7175 19.0104L19.0104 19.7175C18.8151 19.9128 18.4986 19.9128 18.3033 19.7175L14.3347 15.749C13.2598 16.5356 11.9342 17 10.5 17C6.91 17 4 14.09 4 10.5C4 6.91 6.91 4 10.5 4Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9a1071a86f02cdcc094020c7403b7c2f.svg";
export { ForwardRef as ReactComponent };